/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-multi-comp */

import React from 'react';
import { useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';

import { Button } from '@mui/material';

// Material helpers
import { Typography, Grid2 } from '@mui/material';

// Shared layouts
import { Dashboard as DashboardLayout } from 'layouts';

// Custom components
import { GridMeter } from './components';
import { Paper } from 'components';

// Component styles
import styles from './styles';
import { makeStyles } from '@mui/styles';
import { useIntl } from 'react-intl';
import theme from 'theme';
const useStyles = makeStyles(styles);

export default function Meter(props) {
  const intl = useIntl();
  const classes = useStyles();
  const { corpId } = useParams();
  const user = useSelector((state) => state.user.user);

  const corporative = useSelector(
    user.adser == 1
      ? (state) => state.user.corporative
      : (state) => state.user.user.corporative
  );

  const corporatives = useSelector((state) => state.corporatives.corporatives);

  const getBanner = () => {
    let corporativeTMP = corporative;

    if (user.adser === 1) {
      corporativeTMP = corporatives.find((m) => {
        return m.id == corporative.id;
      });
    } else {
      corporativeTMP = corporative;
    }

    if (corporativeTMP == null) {
      return '';
    }

    return (
      <Paper style={{ padding: 10, marginTop: 15 }}>
        <Grid2
          alignItems="center"
          container={true}
          direction="row"
          justify="flex-start"
          style={{ position: 'relative' }}
        >
          <div className={classes.imageWrapper}>{getImage()}</div>

          <div>
            <Typography className={classes.title} variant="h4">
              {corporativeTMP.name}
            </Typography>

            <Typography className={classes.data} variant="h5">
              {corporativeTMP.city} - {corporativeTMP.state}
            </Typography>

            <Typography className={classes.data}>
              {intl.formatMessage({ id: 'app.meters.banner.contact' })}:{' '}
              {corporativeTMP.contact.name}
            </Typography>

            <Typography className={classes.data}>
              {intl.formatMessage({ id: 'app.meters.banner.phone' })}:{' '}
              {corporativeTMP.contact.tel}
            </Typography>
          </div>
          <div style={{ position: 'absolute', top: '0', right: '0' }}>
            <Link
              to={{
                pathname: `/dashboard/${corporativeTMP.id}`,
                state: corporativeTMP,
              }}
            >
              <Button color="secondary" variant="contained">
                Dashboard de Bienvenida
              </Button>
            </Link>
          </div>
        </Grid2>
      </Paper>
    );
  };

  const getImage = () => {
    if (corporative != null) {
      if (corporative.logo != null && corporative.logo != '') {
        return (
          <img alt="Product" className={classes.image} src={corporative.logo} />
        );
      } else {
        return (
          <img
            alt="Product"
            className={classes.image}
            src="images/logo-metimur.png"
          />
        );
      }
    }
  };

  return (
    <DashboardLayout chargeName={corporative.name} title={'Medidores'}>
      <div className={classes.root}>
        <Typography
          style={{ color: '#A53693', marginBottom: theme.spacing(2) }}
          variant="h2"
        >
          {intl.formatMessage({ id: 'app.meters.nav.meters' })}s
        </Typography>
        {getBanner()}
        <div className={classes.content}>
          <GridMeter coporative_id={corpId} />
        </div>
      </div>
    </DashboardLayout>
  );
}
